/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BookingAvailabilityControllerFindAllByPartnerIdParamsGen,
  BookingAvailabilityControllerFindOneByPartnerIdParamsGen,
  BookingBookingConfirmedViewModelGen,
  BookingCreateBookingWithoutResourceDtoGen,
  BookingExceptionViewmodelGen,
  BookingPageViewModelGen,
  BookingServiceBookingViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Availability<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags availability
   * @name AvailabilityControllerCreate
   * @summary Creates a booking request on a given service for a partner
   * @request POST:/partner/{partnerId}/booking
   * @response `201` `BookingBookingConfirmedViewModelGen` Booking created
   * @response `400` `BookingExceptionViewmodelGen` Bad Request
   * @response `500` `BookingExceptionViewmodelGen` Internal Server Error
   */
  availabilityControllerCreate = (
    partnerId: string,
    data: BookingCreateBookingWithoutResourceDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<BookingBookingConfirmedViewModelGen, BookingExceptionViewmodelGen>({
      path: `/partner/${partnerId}/booking`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags availability
   * @name AvailabilityControllerFindAllByPartnerId
   * @summary Gets available booking slots for a service for a partner
   * @request GET:/partner/{partnerId}/availability
   * @response `200` `(BookingPageViewModelGen & { data?: (BookingServiceBookingViewModelGen)[] })`
   * @response `400` `BookingExceptionViewmodelGen` Bad Request
   * @response `500` `BookingExceptionViewmodelGen` Internal Server Error
   */
  availabilityControllerFindAllByPartnerId = (
    { partnerId, ...query }: BookingAvailabilityControllerFindAllByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      BookingPageViewModelGen & { data?: BookingServiceBookingViewModelGen[] },
      BookingExceptionViewmodelGen
    >({
      path: `/partner/${partnerId}/availability`,
      method: "GET",
      query: query,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags availability
   * @name AvailabilityControllerFindOneByPartnerId
   * @summary Gets slots for a particular service from a given partner starting at a particular day
   * @request GET:/partner/{partnerId}/availability/{id}
   * @response `200` `BookingServiceBookingViewModelGen` The service booking view model
   * @response `400` `BookingExceptionViewmodelGen` Bad Request
   * @response `500` `BookingExceptionViewmodelGen` Internal Server Error
   */
  availabilityControllerFindOneByPartnerId = (
    { partnerId, id, ...query }: BookingAvailabilityControllerFindOneByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<BookingServiceBookingViewModelGen, BookingExceptionViewmodelGen>({
      path: `/partner/${partnerId}/availability/${id}`,
      method: "GET",
      query: query,
      format: "json",
      ...params
    });
}
